/**
 * 人の名前は頭文字の丸印 + 氏名で示す（承認者・担当者・申請者）。誰が止めているかが一目で分かる。
 */
export function initials(name: string): string {
  const s = name.trim();
  if (!s) return "?";
  // 日本語の氏名は先頭1文字（姓の頭）、ローマ字は姓名の頭文字2つ
  if (/^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}]/u.test(s)) return s.slice(0, 1);
  const parts = s.split(/[\s.]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? "") + (parts[1]?.[0] ?? "")).toUpperCase() || s.slice(0, 1);
}

export function Person({ name, vacantLabel, sub }: { name: string | null | undefined; vacantLabel?: string; sub?: string }) {
  if (!name) {
    return (
      <span className="person">
        <span className="avatar vacant" aria-hidden="true">?</span>
        <span className="person-name warn">{vacantLabel ?? "—"}</span>
      </span>
    );
  }
  return (
    <span className="person">
      <span className="avatar" aria-hidden="true">{initials(name)}</span>
      <span className="person-name">{name}{sub && <span className="muted small"> {sub}</span>}</span>
    </span>
  );
}
